import { cn } from "@workspace/ui/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const shellVariants = cva("flex h-full w-full flex-col", {
  variants: {
    variant: {
      sidebar: "",
      default: "h-full px-4 pt-2 pb-12 md:px-8",
      centered:
        "flex h-[100dvh] w-full max-w-5xl flex-col justify-center pt-6 pb-8 md:py-8",
      markdown: "max-w-4xl gap-0 py-8 md:py-10 lg:py-10",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

interface ShellProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof shellVariants> {
  as?: React.ElementType;
}

function Shell({
  className,
  as: Comp = "section",
  variant,
  ...props
}: ShellProps) {
  return (
    <Comp className={cn(shellVariants({ variant }), className)} {...props} />
  );
}

// react-doctor-disable-next-line react-doctor/only-export-components -- shadcn/ui registry file — variant exports alongside components is the documented pattern
export { Shell, shellVariants };
